import { useEffect, useState } from "react";
import {  useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../themes/Default/components/Form/components/Input";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { useTranslation } from "react-i18next";
import Divider from "../../../../themes/Default/components/Divider/Divider";
import SummerNote from "../../../../packages/SummerNote/SummerNote";
import { Title } from "../../../../themes/Default/components/Title";
import { useUserToken } from "../../../../hooks/core/UserToken";
import { roles } from "../../../../services/utils/Roles";

const InformationAboutStudent = () => {
    const { t } = useTranslation("common");
    const { studentId } = useParams();
    const { groupId } = useParams();
    const { useViewStudentsMutation } = studentsManagement;
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const [viewStudents] = useViewStudentsMutation();
    const [student, setStudent] = useState()

    const tabs = [
        { title: t("details"), isActive: true },
    ];

    const formatDateToDMY = (value) => {

        const parts = value.split("-");

        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    };

    useEffect(() => {
        viewStudents(studentId).then((result) => {
            setStudent(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            <TopNavigation>
                <ButtonBack to={"/groups/" + groupId + "/attendance"} />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{student?.firstName + " " + student?.lastName}</Title>
                <Breadcrumps>
                    <Link title={t("groups.title")} icon="fa-user-group" />
                    <Link title={t("groups.attendance")} isActive={true} />
                </Breadcrumps>
                <Form>
                    <Row>
                        <Field>
                            <Input
                                label={t("students.gender")}
                                value={student?.gender ? t("students.genderF") : t("students.genderM")}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.isActive")}
                                value={student?.isActive ? t("yes") : t("no")}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field>
                            <Input
                                label={t("students.dateOfBirth")}
                                value={student?.dateOfBirth ? formatDateToDMY(student?.dateOfBirth) : null}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.grade")}
                                value={student?.grade}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field isFullWidth={true}>
                            <Input
                                label={t("students.schoolOrKindergarten")}
                                value={student?.schoolOrKindergartenName}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field>
                            <Input
                                label={t("students.isNew")}
                                value={student?.isNew ? t("yes") : t("no")}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.canBePhotographed")}
                                value={student?.canBePhotographed ? t("yes") : t("no")}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field>
                            <Input
                                label={t("students.hasCatering")}
                                value={student?.hasCatering ? t("yes") : t("no")}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.canGoHomeAlone")}
                                value={student?.canGoHomeAlone ? t("yes") : t("no")}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field isFullWidth={true}>
                            <SummerNote
                                height="200px"
                                label={t("groups.note")}
                                value={student?.note}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Divider title={t("students.guardian1")} />
                    <Row>
                        <Field>
                            <Input
                                label={t("employees.firstName")}
                                value={student?.guardian1FirstName}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("employees.lastName")}
                                value={student?.guardian1LastName}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field>
                            <Input
                                label={t("employees.email")}
                                value={student?.guardian1Email}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.guardianType")}
                                value={student?.guardian1TypeName}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                        <>
                            <Row>
                                <Field>
                                    <Input
                                        label={t("employees.phoneNumber")}
                                        value={student?.guardian1PhoneNumber}
                                        disabled={true}
                                    />
                                </Field>
                                <Field>
                                </Field>
                            </Row>
                        </>
                    )}
                    <Divider title={t("students.guardian2")} />
                    <Row>
                        <Field>
                            <Input
                                label={t("employees.firstName")}
                                value={student?.guardian2FirstName}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("employees.lastName")}
                                value={student?.guardian2LastName}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    <Row>
                        <Field>
                            <Input
                                label={t("employees.email")}
                                value={student?.guardian2Email}
                                disabled={true}
                            />
                        </Field>
                        <Field>
                            <Input
                                label={t("students.guardianType")}
                                value={student?.guardian2TypeName}
                                disabled={true}
                            />
                        </Field>
                    </Row>
                    {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.PROFESSOR_COORDINATOR) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                        <>
                            <Row>
                                <Field>
                                    <Input
                                        label={t("employees.phoneNumber")}
                                        value={student?.guardian2PhoneNumber}
                                        disabled={true}
                                    />
                                </Field>
                                <Field>
                                </Field>
                            </Row>
                        </>
                    )}
                </Form>
            </Main>
        </DefaultLayout>
    );
};

export default InformationAboutStudent;
